export const formatDate = (date) => {
    if (!date) return "";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

export const formatPhone = (phone) => {
    if (!phone) return "-";

    const onlyNumber = String(phone).replace(/\D/g, "");

    if (onlyNumber.length === 11) {
        return onlyNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    }

    if (onlyNumber.length === 10) {
        if (onlyNumber.startsWith("02")) {
            return onlyNumber.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
        }
        return onlyNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    }

    return phone;
};